const currencySymbol = {
  EUR: '€',
  USD: '$',
};

export const getCurrencySymbol = (currency: string = 'USD') => {
  return currencySymbol[currency.toUpperCase()] || currency.toUpperCase();
};
